import React from 'react'
import banner from '../../../assets/images/legals.png'

const NoticeOfPrivacy = props => {
  let { paragraphs } = props.privacy
  return <div>
    <div className='legals__privacy-content' dangerouslySetInnerHTML={{ __html: paragraphs }} />
    <div className='legals__banner' style={{ background: `url(${banner})` }} />
  </div>
}

export default NoticeOfPrivacy
